// All different kinds of statuses
export default {
    getUserStatus(){
        return [
            { label: 'Pending KYC', status: 'pending kyc' },
            { label: 'Approved', status: 'approved' },
            { label: 'Rejected', status: 'rejected' },
            { label: 'Bocked', status: 'blocked' }
        ]
    }
  };
  